 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import EBOOK4252 from '@/components/ebook4252'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK42521 from '@/components/ebook4252-1'
 import EBOOK42522 from '@/components/ebook4252-2'
 import EBOOK42523 from '@/components/ebook4252-3'
 import EBOOK42524 from '@/components/ebook4252-4'
 import EBOOK42525 from '@/components/ebook4252-5'
 import EBOOK42526 from '@/components/ebook4252-6'
 import EBOOK42527 from '@/components/ebook4252-7'
 import EBOOK42528 from '@/components/ebook4252-8'
 import EBOOK42529 from '@/components/ebook4252-9'
 import EBOOK425210 from '@/components/ebook4252-10'
 import EBOOK425211 from '@/components/ebook4252-11'
 import EBOOK425212 from '@/components/ebook4252-12'
 import EBOOK425213 from '@/components/ebook4252-13'
 import EBOOK425214 from '@/components/ebook4252-14'
 import EBOOK425215 from '@/components/ebook4252-15'
 import EBOOK425216 from '@/components/ebook4252-16'
 import EBOOK425217 from '@/components/ebook4252-17'
 import EBOOK425218 from '@/components/ebook4252-18'
 import EBOOK425219 from '@/components/ebook4252-19'
 import EBOOK425220 from '@/components/ebook4252-20'
 import EBOOK425221 from '@/components/ebook4252-21'
 import EBOOK425222 from '@/components/ebook4252-22'
 import EBOOK425223 from '@/components/ebook4252-23'
 import EBOOK425224 from '@/components/ebook4252-24'
 import EBOOK425225 from '@/components/ebook4252-25'
 import EBOOK425226 from '@/components/ebook4252-26'
 import EBOOK425227 from '@/components/ebook4252-27'
 import EBOOK425228 from '@/components/ebook4252-28'
 import EBOOK425229 from '@/components/ebook4252-29'
 import EBOOK425230 from '@/components/ebook4252-30'
 import EBOOK425231 from '@/components/ebook4252-31'
 import EBOOK425232 from '@/components/ebook4252-32'
 import LOVE_2 from '@/components/love_2'
 import EBOOK425233 from '@/components/ebook4252-33'
 import EBOOK425234 from '@/components/ebook4252-34'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/ebook4252",
 			"name" : "ebook4252",
 			"component" : EBOOK4252
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/ebook4252-1",
 			"name" : "ebook4252-1",
 			"component" : EBOOK42521
 		},
 		{
 			"path" : "/ebook4252-2",
 			"name" : "ebook4252-2",
 			"component" : EBOOK42522
 		},
 		{
 			"path" : "/ebook4252-3",
 			"name" : "ebook4252-3",
 			"component" : EBOOK42523
 		},
 		{
 			"path" : "/ebook4252-4",
 			"name" : "ebook4252-4",
 			"component" : EBOOK42524
 		},
 		{
 			"path" : "/ebook4252-5",
 			"name" : "ebook4252-5",
 			"component" : EBOOK42525
 		},
 		{
 			"path" : "/ebook4252-6",
 			"name" : "ebook4252-6",
 			"component" : EBOOK42526
 		},
 		{
 			"path" : "/ebook4252-7",
 			"name" : "ebook4252-7",
 			"component" : EBOOK42527
 		},
 		{
 			"path" : "/ebook4252-8",
 			"name" : "ebook4252-8",
 			"component" : EBOOK42528
 		},
 		{
 			"path" : "/ebook4252-9",
 			"name" : "ebook4252-9",
 			"component" : EBOOK42529
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js